import React, { useRef, useState, useCallback } from 'react';
import Image from '../Image/bundle.esm.js';
import ThumbnailCarouselStyled from './bundle.esm2.js';
import Clickable from '../Clickable/bundle.esm.js';
import Arrow from '../../assets/images/carousel/bundle.esm3.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ThumbnailCarousel = (props) => {
  var _a, _b;
  const { images, className, gap = 8, height, width } = props;
  const { onClickItem, onHoverItem, previousIcon: previousIconProp } = props;
  const { vertical, imageConfig, nextIcon: nextIconProp, errorImage } = props;
  const { showNavigationButtons, slideWidth, slideHeight } = props;
  const { slideClassName, onDoubleClickItem, onRightClick } = props;
  const { activeSlideClassName, onLeftClick } = props;
  const cdnWidth = (_a = imageConfig == null ? void 0 : imageConfig.width) != null ? _a : slideWidth;
  const cdnHeight = (_b = imageConfig == null ? void 0 : imageConfig.height) != null ? _b : slideHeight;
  const sliderRef = useRef(null);
  const [localIndex, setLocalIndex] = useState(0);
  const defaultPrevIcon = !vertical ? /* @__PURE__ */ React.createElement(Arrow, null) : /* @__PURE__ */ React.createElement(Arrow, {
    className: "ThumbnailCarousel__action--90"
  });
  const defaultNextIcon = !vertical ? /* @__PURE__ */ React.createElement(Arrow, {
    className: "ThumbnailCarousel__action--180"
  }) : /* @__PURE__ */ React.createElement(Arrow, {
    className: "ThumbnailCarousel__action--270"
  });
  const previousIcon = previousIconProp ? previousIconProp : defaultPrevIcon;
  const nextIcon = nextIconProp ? nextIconProp : defaultNextIcon;
  if (width && slideWidth > width + gap) {
    console.warn("width must be greater than slideWidth");
  }
  if (slideHeight && height && slideHeight > height + gap) {
    console.warn("height must be greater than slideHeight");
  }
  const clickHandler = useCallback(
    (action) => {
      const slider = sliderRef.current;
      if (!slider)
        return;
      const factor = action === "previous" ? -1 : 1;
      const actualScroll = vertical ? slider.scrollTop : slider.scrollLeft;
      const slideSize = (vertical ? slideHeight : slideWidth) + gap;
      let newScroll = actualScroll + slideSize * factor;
      if (newScroll < 0) {
        newScroll = 0;
      }
      const scrollLimit = vertical ? slider.scrollHeight - slider.offsetHeight : slider.scrollWidth - slider.offsetWidth;
      if (newScroll >= scrollLimit) {
        newScroll = vertical ? slider.scrollHeight - slideHeight - gap : slider.scrollWidth - slideWidth - gap;
      }
      const scrollDirection = vertical ? { top: newScroll } : { left: newScroll };
      slider.scrollTo(__spreadProps(__spreadValues({}, scrollDirection), { behavior: "smooth" }));
    },
    [gap, slideHeight, slideWidth, vertical]
  );
  const rightClickHandler = (e) => {
    onRightClick == null ? void 0 : onRightClick(e);
    clickHandler("previous");
  };
  const leftClickHandler = (e) => {
    onLeftClick == null ? void 0 : onLeftClick(e);
    clickHandler("next");
  };
  const clickItemHandler = (index) => {
    onClickItem == null ? void 0 : onClickItem(index);
    setLocalIndex(index);
  };
  const mouseEnterItemHandler = (index) => {
    onHoverItem == null ? void 0 : onHoverItem(index);
    setLocalIndex(index);
  };
  const doubleClickItemHandler = (index) => {
    onDoubleClickItem == null ? void 0 : onDoubleClickItem(index);
    setLocalIndex(index);
  };
  return /* @__PURE__ */ React.createElement(ThumbnailCarouselStyled, {
    className: `ThumbnailCarousel ${className}`,
    itemWidth: slideWidth,
    itemHeight: slideHeight,
    width,
    height,
    gap,
    vertical
  }, showNavigationButtons ? /* @__PURE__ */ React.createElement(Clickable, {
    className: "ThumbnailCarousel__action",
    onClick: leftClickHandler
  }, previousIcon) : null, /* @__PURE__ */ React.createElement("ul", {
    className: "ThumbnailCarousel__slider",
    ref: sliderRef
  }, images == null ? void 0 : images.map((image, index) => {
    return /* @__PURE__ */ React.createElement("li", {
      onClick: () => clickItemHandler(index),
      onMouseEnter: () => mouseEnterItemHandler(index),
      onDoubleClick: () => doubleClickItemHandler(index),
      className: `ThumbnailCarousel__slider-item ${slideClassName} ${localIndex === index && activeSlideClassName ? activeSlideClassName : ""}`,
      key: index
    }, /* @__PURE__ */ React.createElement(Image, {
      draggable: false,
      image,
      width: slideWidth,
      height: slideHeight,
      config: __spreadValues({
        width: cdnWidth,
        height: cdnHeight
      }, imageConfig),
      alt: `slide-${index}`,
      errorImage
    }));
  })), showNavigationButtons ? /* @__PURE__ */ React.createElement(Clickable, {
    className: "ThumbnailCarousel__action",
    onClick: rightClickHandler
  }, nextIcon) : null);
};
ThumbnailCarousel.defaultProps = {
  className: "",
  slideClassName: "",
  activeSlideClassName: "",
  showNavigationButtons: true,
  gap: 8
};

export { ThumbnailCarousel as default };
//# sourceMappingURL=bundle.esm.js.map
